import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Layout, Menu } from 'antd';
import classnames from 'classnames';
import { connect } from 'react-redux';

import Logo from 'components/Logo/Logo';
import withAuthentication from 'hoc/authentication';
import { hasGroup } from 'helpers/permissionsHelpers';
import withHeaderPermissions from './withHeaderPermissions';
import styles from './Header.module.scss';

const HeaderBrand = () => (
  <div className={styles.header__top}>
    <Link to="/" className={styles['header__logo-link']}>
      <Logo className={styles['header__logo-item']} />
      Office National des forêts
    </Link>
  </div>
);

const getNLevels = groups => {
  if (hasGroup(groups, 'N1')) {
    return ' (Niv 1) ';
  }
  if (hasGroup(groups, 'N2')) {
    return ' (Niv 2) ';
  }
  return ' ';
};

const getUserLabel = ({ properties: { firstName, lastName, structure } }) => (
  firstName
    ? `${firstName} ${lastName}`
    : `${structure ? structure.name : 'Ma structure'}`
);

const Header = ({
  isAuthenticated,
  logout,
  groups,
  user,
  permissions: {
    isStaff,
    canReadRequests,
    canCreateRequests,
    canAccessAdmin,
    canManageUsers,
    canUpdateFeatures,
    canUpdateTemplate,
    canManageActivities,
    canEditCMS,
  } = {},
  cmsUrl,
}) => (
  <Layout.Header className={styles.header}>
    <div className={styles.menu}>
      <nav className="wrapper">
        <HeaderBrand />
        {(isAuthenticated && user) ? (
          <Menu mode="horizontal" className={styles.menuLinks} style={{ border: 'none' }}>
            <Menu.Item key="home"><Link to="/"><Icon type="home" /> Accueil</Link></Menu.Item>
            {canReadRequests && (
              <Menu.Item
                key="manage-request"
              >
                <Link to="/manage-request"><Icon type="file-text" />
                  {isStaff ? 'Déclarations' : 'Mes déclarations'}
                </Link>
              </Menu.Item>
            )}
            {isStaff && (
              <Menu.Item
                key="statistics"
              >
                <Link to="/statistics"><Icon type="line-chart" />Statistiques</Link>
              </Menu.Item>
            )}
            {isStaff && (
              <Menu.Item
                key="agenda"
              >
                <Link to="/agenda"><Icon type="calendar" />Agenda</Link>
              </Menu.Item>
            )}
            {canAccessAdmin && (
              <Menu.SubMenu
                className={styles['menuLinks__item-right']}
                title={(
                  <span>
                    <Icon type="setting" />
                      Admin
                    <Icon type="down" />
                  </span>
                  )}
              >
                {canManageUsers && (
                  <Menu.Item key="users">
                    <Link to="/administration/users"><Icon type="team" />
                      Agents et zones de triage
                    </Link>
                  </Menu.Item>
                )}
                {canUpdateFeatures && (
                  <Menu.Item key="upload">
                    <Link to="/administration/upload-files"><Icon type="global" />
                      Données cartographiques
                    </Link>
                  </Menu.Item>
                )}
                {canUpdateTemplate && (
                  <Menu.Item key="templates">
                    <Link to="/administration/update-templates"><Icon type="file-text" />
                      Modèles de documents
                    </Link>
                  </Menu.Item>
                )}
                {canManageActivities && (
                  <Menu.Item key="activities">
                    <Link to="/administration/activities"><Icon type="form" />
                      Édition de formulaires
                    </Link>
                  </Menu.Item>
                )}
                {canEditCMS && (
                  <Menu.Item key="cms">
                    <a
                      href={cmsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    ><Icon type="edit" />
                      Édition des pages publiques
                    </a>
                  </Menu.Item>
                )}
              </Menu.SubMenu>
            )}
            <Menu.SubMenu
              className={classnames({
                [styles['menuLinks__item-right']]: !canAccessAdmin,
              })}
              title={(
                <span>
                  <Icon type="user" />
                  {getUserLabel(user)}
                  {getNLevels(groups)}
                  <Icon type="down" />
                </span>
              )}
            >
              <Menu.ItemGroup className={styles.submenu} title={<span>{user.email}</span> || 'email'}>
                <Menu.Item key="account"><Link to="/account"><Icon type="setting" /> Modifier mon mot de passe</Link></Menu.Item>
                <Menu.Item key="profile"><Link to="/profile"><Icon type="user" /> Profil</Link></Menu.Item>
                <Menu.Item className={styles.submenu} onClick={logout}>
                  <Icon type="logout" />Se déconnecter
                </Menu.Item>
              </Menu.ItemGroup>
            </Menu.SubMenu>
          </Menu>
        ) : (
          <Menu mode="horizontal" className={styles.menuLinks} style={{ border: 'none' }}>
            <Menu.Item key="home"><Link to="/"><Icon type="home" /> Accueil</Link></Menu.Item>
            {canCreateRequests &&
              <Menu.Item key="request"><Link to="/new-request"><Icon type="file-add" /> Déclarer une activité</Link></Menu.Item>
            }
            <Menu.Item className={styles['menuLinks__item-right']}><Link to="/login"><Icon type="login" />Se connecter</Link></Menu.Item>
          </Menu>
        )}
      </nav>
    </div>
  </Layout.Header>
);

const mapStateToProps = ({ appConfig: { CMS_URL: cmsUrl } }) => ({
  cmsUrl,
});

export default connect(mapStateToProps)(withAuthentication(withHeaderPermissions(Header)));



// WEBPACK FOOTER //
// ./src/components/Layout/Header/Header.js